import React, { useState } from "react";
import { MinusIcon, PlusIcon } from "../IconTheme";

const IncDecInput = () => {
	const [value, setValue] = useState(100);

	const handleChange = (e, amount) => {
		if (Number.isNaN(value) || value === "") {
			setValue(0);
		} else {
			if (e === "inc") {
				setValue(parseInt(value) + amount);
			} else {
				value >= amount ? setValue(parseInt(value) - amount) : setValue(0);
			}
		}
	};
	return (
		<>
			<div className="d-flex">
				<div
					className="dec"
					type="button"
					onClick={() => handleChange("dec", 200)}
				>
					<MinusIcon />
				</div>
				<div className="inc-input d-flex align-items-center justify-content-center">
					<span className="mt-2">${value}</span>
					<input
						type="number"
						value={value}
						onChange={(e) => {
							if (Number.isNaN(value)) {
								setValue(0);
							} else {
								setValue(e.target.value);
							}
						}}
					/>
				</div>
				<div
					className="inc"
					type="button"
					onClick={() => handleChange("inc", 100)}
				>
					<PlusIcon />
				</div>
			</div>
		</>
	);
};

export default IncDecInput;
